"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0m12.351-2.144a.5.5 0 1 0-.702-.712l-4.708 4.65-2.13-1.686a.5.5 0 0 0-.621.784l2.825 2.234z"
}), 'CheckCircleFilled');
